import * as React from 'react';
import { getPaymentImplementation, getPaymentMethodSettings } from '../Payments/providers.js';
import { useAdyen } from '../../../context/Adyen/context.js';

const usePaymentMethodForm = ()=>{
    const { config  } = useAdyen();
    const [selectedPaymentDetails, setSelectedPaymentDetails] = React.useState();
    const handlePaymentDataChange = React.useCallback((paymentData, isValid)=>{
        setSelectedPaymentDetails({
            data: paymentData,
            isValid
        });
    }, []);
    const resetPaymentDetails = React.useCallback(()=>{
        setSelectedPaymentDetails(undefined);
    }, []);
    const renderPaymentForm = React.useCallback((selectedPaymentMethod)=>{
        if (!selectedPaymentMethod) {
            return null;
        }
        const implementation = getPaymentImplementation(selectedPaymentMethod.provider, selectedPaymentMethod.type);
        // Get settings that are passed to payment settings provider from the OpCo site
        const settings = getPaymentMethodSettings(selectedPaymentMethod.provider, selectedPaymentMethod.type, config);
        if (!implementation || !implementation.form) {
            return null;
        }
        return /*#__PURE__*/ React.createElement(implementation.form, {
            onChange: handlePaymentDataChange,
            config: selectedPaymentMethod.config,
            settings
        });
    }, [
        config,
        handlePaymentDataChange
    ]);
    return React.useMemo(()=>[
            renderPaymentForm,
            selectedPaymentDetails,
            resetPaymentDetails
        ]
    , [
        renderPaymentForm,
        selectedPaymentDetails,
        resetPaymentDetails
    ]);
};

export { usePaymentMethodForm };
//# sourceMappingURL=use-payment-method-form.js.map
